import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
    status: number;
    message: string;
    statusCode: number;
}

export const SubacriptionApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getSubscription: builder.query<
            CommonResponseType & { data: any },
            {
                search?: string;
            }
        >({
            query: ({ search } = {}) => ({
                url: `${END_POINTS.subscriptionList}${search && search.trim() !== ""
                    ? `?search=${encodeURIComponent(search)}`
                    : ""
                    }`,
                method: "GET",
            }),
        }),
        

    }),
});

export const {
    useLazyGetSubscriptionQuery
} = SubacriptionApi;
